<template>
  <MapPopup
      v-if="event"
      icon="icon-object"
      :title="object?.name"
      :call-action="!!eventCallAction"
      @callAction="callAction(eventCallAction)"
      @close="emit('close')"
  >
    <div class="map-popup__row">
      <span class="label">
        {{ $t('front.address') }}
      </span>

      <Address full
               :lat="event.latitude"
               :lng="event.longitude"
      >
        <template #default="{address}">
          <span class="value">
            {{ address }}
          </span>
        </template>
      </Address>
    </div>

    <div class="map-popup__row">
      <div class="label">
        {{ $t('front.preview')}}
      </div>

      <div class="value">
        <a :href="`http://maps.google.com/?q=&cbll=${event.latitude},${event.longitude}&cbp=12,20.09,,0,5&layer=c&hl=${null}`" target="_blank">
          {{ $t('front.preview') }} &gt;&gt;
        </a>
      </div>
    </div>

    <div class="map-popup__row">
      <div class="label">
        {{ $t('front.latitude') }}
      </div>
      <div class="value">
        {{ event.latitude }}&deg;
      </div>
    </div>

    <div class="map-popup__row">
      <div class="label">
        {{ $t('global.longitude') }}
      </div>
      <div class="value">
        {{ event.longitude }}&deg;
      </div>
    </div>

    <div class="map-popup__row">
      <div class="label">
        {{ $t('front.altitude') }}
      </div>
      <div class="value">
        {{ event.altitude }}
      </div>
    </div>

    <div class="map-popup__row">
      <div class="label">
        {{ $t('front.speed') }}
      </div>
      <div class="value">
        {{ event.speed }}
      </div>
    </div>

    <div class="map-popup__row">
      <div class="label">
        {{ $t('front.time') }}
      </div>
      <div class="value">
        {{ event.time }}
      </div>
    </div>
  </MapPopup>
</template>
<script setup>
import MapPopup from "@/js/Components/MapPopup/Popup.vue";
import Address from "@/js/Elements/Address.vue";
import {computed} from "vue";
import {useStore} from "vuex";
import {useAction} from "@/js/Plugins/Action.js";

const store = useStore();
const props = defineProps({
  id: [String, Number],
});
const emit = defineEmits(['close']);
const callAction = useAction();
const event = computed(() => {
  const evt = store.getters['event/find'](props.id);
  if (evt) return evt;
  return store.getters['recent-event/find'](props.id);
});

const eventCallAction = computed(() => {
  const actions = event.value?.config?.actions;
  if (!actions) return;
  return actions.find(a => {
    return a?.redirect?.name && a.redirect.name.match(/(call-action.form)$/)
  });
});

store.commit('map/disableFitBounds');
const object = computed(() => store.getters['object/find'](event.value?.device_id));
</script>
